/* Tiptap Editor Styles */
.tiptap-editor-content .ProseMirror {
  outline: none;
  min-height: 220px;
  padding: 14px 16px;
  line-height: 1.65;
  font-size: 14px;
}

.tiptap-editor-content .ProseMirror > * + * {
  margin-top: 0.6em;
}

.tiptap-editor-content .ProseMirror p {
  margin: 0;
}

/* Geist ships as named single-weight families — font-weight alone can't reach
   the semibold face, so headings/bold swap the family instead. */
.tiptap-editor-content .ProseMirror h1 {
  font-family: 'Geist_semibold';
  font-weight: normal;
  font-size: 1.6em;
  line-height: 1.3;
  margin-top: 1em;
  margin-bottom: 0.25em;
}

.tiptap-editor-content .ProseMirror h2 {
  font-family: 'Geist_semibold';
  font-weight: normal;
  font-size: 1.3em;
  line-height: 1.35;
  margin-top: 1em;
  margin-bottom: 0.25em;
}

.tiptap-editor-content .ProseMirror h3 {
  font-family: 'Geist_semibold';
  font-weight: normal;
  font-size: 1.1em;
  line-height: 1.4;
  margin-top: 0.75em;
  margin-bottom: 0.25em;
}

.tiptap-editor-content .ProseMirror ul,
.tiptap-editor-content .ProseMirror ol {
  padding-left: 1.4em;
  margin: 0.4em 0;
}

.tiptap-editor-content .ProseMirror li {
  margin: 0.2em 0;
}

.tiptap-editor-content .ProseMirror a {
  color: #3b82f6;
  text-decoration: underline;
  cursor: pointer;
}

.tiptap-editor-content .ProseMirror strong,
.tiptap-editor-content .ProseMirror b {
  font-family: 'Geist_semibold';
  font-weight: normal;
}

.tiptap-editor-content .ProseMirror em {
  font-style: italic;
}

.tiptap-editor-content .ProseMirror u {
  text-decoration: underline;
}

.tiptap-editor-content .ProseMirror s {
  text-decoration: line-through;
}

.tiptap-editor-content .ProseMirror blockquote {
  border-left: 3px solid rgba(128,128,128,0.4);
  padding-left: 1em;
  margin: 0.5em 0;
  opacity: 0.75;
  font-style: italic;
}

.tiptap-editor-content .ProseMirror code {
  background-color: rgba(128,128,128,0.15);
  padding: 0.15em 0.4em;
  border-radius: 4px;
  font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  font-size: 0.875em;
}

.tiptap-editor-content .ProseMirror pre {
  background-color: rgba(0,0,0,0.8);
  color: #f9fafb;
  padding: 1em;
  border-radius: 8px;
  overflow-x: auto;
  margin: 0.5em 0;
}

.tiptap-editor-content .ProseMirror pre code {
  background-color: transparent;
  padding: 0;
  color: inherit;
  font-size: 0.875em;
}

.tiptap-editor-content .ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: rgba(128,128,128,0.5);
  pointer-events: none;
  height: 0;
}
